
export class GetProgramTopoStation {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            // Lynx Cloud API sometimes uses PascalCase and sometimes camelCase
            // Lynx Drive API uses camelCase.
            this.id = json.Id ?? json.id;
            this.name = json.Name ?? json.name;
            this.stationId = json.StationId ?? json.stationId;

            delete this['Id'];
            delete this['Name'];
            delete this['StationId'];
        }
    }

    stationId: number;
    id: number;
    name: string;
}
